import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-decoration-angle-left-top",
  "use": "icon-decoration-angle-left-top-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-decoration-angle-left-top\">\r\n<line x1=\"16\" y1=\"18.5\" y2=\"18.5\" stroke=\"white\" />\r\n<line x1=\"18.5\" y1=\"18\" x2=\"18.5\" y2=\"-2.18557e-08\" stroke=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol